import SuperSliderUnstyled from "@marginly/ui/components/input/super-slider";
import { SLIDER_TRACK_CLASSNAME } from "@marginly/ui/components/input/super-slider/action-typography";
import { cssVar } from "@marginly/ui/util/style";
import styled from "styled-components";

export const CRITICAL_CLASS = "critical";

export const SuperSlider = styled(SuperSliderUnstyled)`
  &.${CRITICAL_CLASS} {
    .${SLIDER_TRACK_CLASSNAME} {
      color: ${cssVar("--fill-negative")};
    }
  }
`;
